import Link from 'next/link';
import { blogCategoryPath, PAGE_PATHS } from '../Router';
import type { BlogCategoryDocument } from '../../firebase/blog-db';
import { cn } from '../ui/utils';

interface CategoryPillNavProps {
  categories: BlogCategoryDocument[];
  activeSlug?: string;
}

export function CategoryPillNav({ categories, activeSlug }: CategoryPillNavProps) {
  if (categories.length === 0) return null;
  return (
    <nav aria-label="Blog categories" className="border-b border-gray-100 bg-white sticky top-14 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 overflow-x-auto py-3 no-scrollbar">
          <Link
            href={PAGE_PATHS['blog-home']}
            className={cn(
              'flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-medium transition-colors',
              !activeSlug ? 'bg-hustlance-primary text-white' : 'text-gray-600 hover:bg-gray-100'
            )}
          >
            All
          </Link>
          {categories.map(cat => (
            <Link
              key={cat.id}
              href={blogCategoryPath(cat.slug)}
              className={cn(
                'flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-medium transition-colors',
                activeSlug === cat.slug ? 'bg-hustlance-primary text-white' : 'text-gray-600 hover:bg-gray-100'
              )}
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
